import { useEffect, useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import MotoristasTable from "../../../components/motoristas/table/indes";
import { VerticalContainer } from "../../../components/styled";
import history from "../../../routes/history";
import { deleteMotorista, getMotoristas } from "../../../services/motoristas";
import { cancelarViagem, deleteViagem, finalizarViagem, getViagens } from "../../../services/viagens";
import ViagensTable from "../../../components/viagens/table";
import { realizarSolicitacao } from "../../../services/solicitacoes";

const { Search } = Input;

export default function ListViagens() {
  const [filter, setFilter] = useState("");
  const [viagens, setViagens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const getViagensPaginated = async () => {
    setLoading(true);
    try {
      const viagemGet = await getViagens(page, filter);
      setViagens(viagemGet);
      setTotal(viagemGet.length);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getViagensPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteViagem(record.id);
    await getViagensPaginated();
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter("");
  };

  const finalizar = async (record) => {
    await finalizarViagem(record.id);
    await getViagensPaginated();
  }

  const cancelar = async (record, motivo) => {
    await cancelarViagem(record.id, motivo)
    await getViagensPaginated();
  }
  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: "50%" }}
          placeholder="Pesquisar viagem..."
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push("/adicionar-viagem");
          }}
          style={{ width: "100%!important" }}
          block
        >
          <PlusOutlined />
          Adicionar viagem
        </Button>
        <br />
        <ViagensTable
          loading={loading}
          handleTableChange={handleTableChange}
          viagens={viagens}
          total={total}
          cancelar={cancelar}
          finalizar={finalizar}
          confirm={confirm}
        />
      </VerticalContainer>
    </>
  );
}
